import type { FieldReference } from '@moment/horizon-data-access/platform'

import { parseClientColumnId } from '@/shared/sorm/cross-entity-columns'

interface DisplayLabelFieldForArgs {
  columnId: string
  rootEntity: string
}

/** Fields whose raw value is an opaque key, mapped to the field shown in its place. */
const DISPLAY_LABEL_FIELDS: Record<string, FieldReference> = {
  'Proposal.batch_key': { entity: 'Proposal', field: 'name' },
}

export function displayLabelFieldFor({
  columnId,
  rootEntity,
}: DisplayLabelFieldForArgs): FieldReference | undefined {
  const { entity, field } = parseClientColumnId({ columnId, rootEntity })
  return DISPLAY_LABEL_FIELDS[`${entity}.${field}`]
}
